module.exports = __webpack_public_path__ + "static/media/normal video.7ea198b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/normal video.mp4
// module id = 6VT5
// module chunks = 2